export default __webpack_public_path__ + "static/media/charcIcon.fd5d449b.jpg";